module.exports = __webpack_public_path__ + "static/media/Oil-red.cfa8dbd6.svg";